import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { ArrowRight, FormUI, IconButton, SimpleImage, Typography } from "@parkschannel/ui";
export const ReservationSection = ()=>{
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-white py-6 px-4 rounded-2xl flex items-center md:px-6",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "w-full flex gap-6 justify-between",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "md:py-[20px] lg:py-[27px]",
                    children: /*#__PURE__*/ _jsxs(FormUI.Step, {
                        step: 1,
                        status: "active",
                        title: ()=>/*#__PURE__*/ _jsx(Typography, {
                                component: "h2",
                                variant: "h4",
                                className: classNames("text-neutral-900"),
                                children: "Check for Availability"
                            }),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "bodyXL",
                                className: "mb-6 text-neutral-700",
                                children: "Is your destination one of the most popular parks? If so, check to see if you need a reservation."
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "https://www.recreation.gov",
                                target: "_blank",
                                children: /*#__PURE__*/ _jsx(IconButton, {
                                    tabIndex: -1,
                                    icon: /*#__PURE__*/ _jsx(ArrowRight, {}),
                                    children: "Check Recreation.gov"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "hidden md:block",
                    children: /*#__PURE__*/ _jsx(SimpleImage, {
                        src: "/media/illustrations/videos-not-found.webp",
                        className: "object-contain object-left",
                        alt: "Reservation",
                        width: 200,
                        height: 200
                    })
                })
            ]
        })
    });
};
